import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import PostData from "../../../Api/PostData";
// import Wave from "../../../Assets/Img/wave.png";
import Navbar from "../../Atoms/Navbar";
import XMLParser from "react-xml-parser";
import GetData from "../../../Api/GetData";
// import warning from '../../../Assets/Img/warning.png'
import EditFormErrorScreen from '../Otp/EditFormAfterError'
import { useNavigate } from 'react-router-dom';
import SuccessFormScreen from './SuccessForm'
import Questions from "../../Atoms/Question";
import analytics from '../../../firebase.config';

import { getAnalytics, logEvent } from "firebase/analytics";
const Otp = (props) => {

  const [otp, setOtp] = useState("");
  const [ReOTP, setReOtp] = useState("");
  const [error, setError] = useState("");
  const [showVerifyingOtpModal, setShowVerifyingOtpModal] = useState(false);
  const [showVerifyingOtpWithValueModal, setShowVerifyOtpWithValueModal] = useState(false);
  const [showValidatingOtpModal, setShowValidatingOtpModal] = useState(false);
  const [showThankyouModal, setShowThankYouModal] = useState(false);
  const [showValidatingOtpErrorModal, setValidatingOtpErrorModal] = useState(false);
  const [validatingOtpError, setValidatingOtpError] = useState(false);
  const [showerr, setshowerr] = useState(false);
  const [sendingOtpReq, setSendingOtpReq] = useState(false);
  const [showOtpSendError, setShowOtpSendError] = useState(false);
  const [optSendreqMessage, setOtpSendReqMessage] = useState('');
  const [showStatusValue, setShowStatusValue] = useState('OTP Awaiting');
  const [showStatusLoader, setShowStatusLoader] = useState(false);
  const [showSuccessAfterOtpVarification, setShowSuccessAfterOtpVarification] = useState(false);

  const history = useNavigate();
  useEffect(() => {
    const response = GetData.CheckStatus();


    response.then((value) => {
      // setShowStatusValue(value?.data?.message ? value?.data?.message : value?.data?.StatusService?.data?._text);

      const apidResponse = PostData.SaveApiDStatus(value?.data?.StatusService?.data?._text);
      apidResponse.then((val) => {
        console.log('value for status check is============>>>', val)

      })
      console.log('otp value is================????????', value)

      if (JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("710 =") == true
        || JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("711 =") == true
        || JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("712 =") == true
        || JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("713 =") == true
        || JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("715 =") == true
        || JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("716 =") == true
        || JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("717 =") == true
        || JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("740 =") == true
        || JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("741 =") == true
        || JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("742 =") == true
        || JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("743 =") == true
        || JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("744 =") == true
        || JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("745 =") == true
        || JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("747 =") == true

      ) {
        setShowStatusValue("OTP Received");
        // setShowSuccessAfterOtpVarification(true)
      }
      else if (JSON.stringify(value?.data?.StatusService?.data?._text)?.includes("709 =") == true) {
        setShowStatusValue("OTP Awaiting");
      }
      else {

        console.log('value?.data?.StatusService?.data?._text', value?.data?.StatusService?.data?._text)
        setValidatingOtpError(value?.data?.StatusService?.data?._text ? value?.data?.StatusService?.data?._text : value?.data?.message)

        setshowerr(true)
        setShowStatusValue("OTP Rejected");
      }
      // setShowStatusValue(value?.data?.message ? value?.data?.message : 'OTP-Awaiting');
      // setShowStatusValue(value?.data?.Stamp ? value?.data?.Stamp : 'OTP-Awaiting');
      setShowStatusLoader(true)
    })
  }, []);


  const openModel = () => {
    // Get the modal

    var modal = document.getElementById("verifyOtpModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close");
    // When the user clicks the button, open the modal
    modal.style.display = "block";

    // When the user clicks on <span> (x) or Close, close the modal

    for (let i = 0; i < span.length; i++) {
      span[i].onclick = function () {
        modal.style.display = "none";
        logEvent(analytics, 'dashb_verify_OTP_press_cancel');
      };
    }
    // When the user clicks anywhere outside of the modal, close it
    // window.onclick = function (event) {
    //   if (event.target == modal) {
    //     modal.style.display = "none";
    //   }
    // };
  };

  const openModalToVerifyOtp = async () => {
    logEvent(analytics, 'dashb_press_verify_otp');
    await setShowVerifyOtpWithValueModal(true)
    await openModel()
  }


  const openThankyouModal = () => {
    // Get the modal
    var modal = document.getElementById("ThankyouModal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close");
    // When the user clicks the button, open the modal
    modal.style.display = "block";

    // When the user clicks on <span> (x) or Close, close the modal

    for (let i = 0; i < span.length; i++) {
      span[i].onclick = function () {
        modal.style.display = "none";
      };
    }
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    };
  };

  const verifyOtpSubmit = () => {
    logEvent(analytics, 'dashb_verify_OTP_press_submit');
  }


  const handleSubmit = (e) => {
    e?.preventDefault();
    setShowVerifyOtpWithValueModal(false)
    setShowVerifyingOtpModal(true)
    setShowValidatingOtpModal(false)
    setShowThankYouModal(false)
    const res = PostData.VerifyOtp(otp);

    res
      .then((value) => {

        if (JSON.stringify(value).includes("313 =") == true || JSON.stringify(value).includes("300 =") == true || JSON.stringify(value).includes("314 =") == true || JSON.stringify(value).includes("315 =") == true) {

          setShowVerifyingOtpModal(false)
          setShowThankYouModal(true)
          logEvent(analytics, 'dashb_verify_OTP_success');


          console.log('verify otp is=========', value)


          // response.then((value) => {
          //   // setShowStatusValue(value?.data?.message ? value?.data?.message : value?.data?.StatusService?.data?._text);

          //   const apidResponse = PostData.SaveApiDStatus(value?.data?.StatusService?.data?._text);
          //   apidResponse.then((val) => {
          //     console.log('value for status check is============>>>', val)

          //   })
          // })

          // setShowValidatingOtpModal(true)
          // setShowThankYouModal(false)
          // setShowVerifyOtpWithValueModal(false)
          // setShowThankYouModal(false)

          // const infoResponse = GetData.getDetailInfotData();
          // infoResponse.then((value) => {
          //   console.log('value is =========>>>', value) 


          //   if (JSON.stringify(value).includes("400") == true || JSON.stringify(value).includes("450") == true) {

          //     setShowThankYouModal(true)


          //     setShowValidatingOtpModal(false)
          //     setShowVerifyOtpWithValueModal(false)
          //     setShowVerifyingOtpModal(false)
          //   }
          //   else {
          //     setValidatingOtpError(value?.data?.DDService?.data?.Message?._text)
          //     setValidatingOtpErrorModal(true)


          //     setShowThankYouModal(false)
          //     setShowValidatingOtpModal(false)
          //     setShowVerifyOtpWithValueModal(false)
          //     setShowVerifyingOtpModal(false)

          //   }
          // })

        }

        else {
          setError(value?.data?.KYCService?.data?.Message?._text ? value?.data?.KYCService?.data?.Message?._text : value?.data?.OTPService?.data?.Message?._text)
          setShowVerifyOtpWithValueModal(true)
          setShowVerifyingOtpModal(false)
          logEvent(analytics, 'dashb_verify_OTP_error');
          openModel()

        }

        console.log("error", error);
      })
      .catch((error) => {
        console.log(error.response);
      });
  };
  const handleFormSubmit = (e) => {
    e?.preventDefault();
    const res = PostData.ResendOtp(ReOTP);

    res
      .then((value) => {
        var xml = new XMLParser().parseFromString(value.data);

        setError(xml.children[0].children[0].value);

        if (xml.children[0].children[0].value.includes('300')) {
          openThankyouModal()
        }
        else {
          setError(xml.children[0].children[0].value);
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  const moveToErrorScreen = () => {
    setshowerr(true)

  }
  const handleWhatsapp = () => {
    window.open('https://api.whatsapp.com/send/?phone=923146398227&text&app_absent=0', '_blank').focus();
  }
  const ResendOTP = () => {
    logEvent(analytics, 'dashb_press_resend_OTP');
    setSendingOtpReq(true)
    const res = GetData.ResendOtp();
    res.then((value) => {
      setSendingOtpReq(false)
      setShowOtpSendError(true)
      setOtpSendReqMessage(value?.data?.OTPService?.data?.Message?._text)
      logEvent(analytics, 'dashb_resend_OTP_success');

    }).catch((error) => {
      console.log(error.response);
      logEvent(analytics, 'dashb_resend_OTP_error');
    });
  }


  const handleSuccessScreen = () => {
    history('/successotp')

    // setShowSuccessAfterOtpVarification(true)
    // setShowThankYouModal(false)
  }


  return (
    <>
      {showerr == false ? (
        <>
          {showSuccessAfterOtpVarification == false && (
            <>

              <Navbar />
              <div className="bg-color">
                <div className="container py-5">
                  <div className="row">
                    <div className="col-md-8">



                      <div className="bg-white mt-3 edge-welcome p-3 p-lg-4">
                        <p className="fs32 ls4 t-grey-800 fw-800">Almost there!</p>
                        <p className="t-grey-600 fs16  mb-5">
                          Your trading account submission is being verified. If you're a resident in Pakistan, you'll receive
                          the OTP via SMS from 9646 (National Clearing Company of Pakistan - NCCPL). If you're a non-resident your OTP will be sent to you via email from NCCPL. Please occasionally check your junk mail to not miss the OTP. <br /> <br />

                          NCCPL is the institution responsible for opening trading accounts.
                        </p>


                        {/* <div className="d-flex flex-wrap justify-content-between mxWidth400">
                          <button
                            type="button"
                            onClick={openModalToVerifyOtp}
                            className="NavButton btn mb-2 px-2 px-md-3 py-2"
                            data-toggle="verifyotpmodal"
                            data-target="#verifyOtpModal"
                          >
                            Verify OTP
                      </button>

                          <button
                            className="Resend mb-2  btn btn-outlined px-2 px-md-3 py-2 "
                            type='button'
                            onClick={ResendOTP}
                          >
                            {sendingOtpReq ? (
                              <div className="spinner-border text-spinner-color" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            ) : (
                              <> Resend OTP</>
                            )}
                          </button>
                         
                       
                          <button className={` otpBtn px-2 px-md-3 btn mb-2 ${showStatusValue == 'OTP Received' ? 'Received' : 'Awaiting'}`}>
                            {showStatusLoader == false ? (
                              <div className="spinner-border text-spinner-color" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            ) : (
                              <>
                                {showStatusValue}
                              </>

                            )}


                          </button>

                          
                        </div> */}
                        <div className="wMd100 d-block d-md-flex flex-wrap justify-content-between mxWidth400 flex-row">
                          <div className="flex11-auto">
                            <button
                              type="button"
                              onClick={openModalToVerifyOtp}
                              className="NavButton wMd100 btn mt-1 my-md-0 mb-0 h-100 px-2 px-md-3 py-2"
                              data-toggle="verifyotpmodal"
                              data-target="#verifyOtpModal"
                            >
                              Verify OTP
                            </button>
                          </div>
                          <div className="flex11-auto">
                            <button
                              className="Resend wMd100 btn btn-outlined mt-3 my-md-0 mb-0 h-100 px-2 px-md-3 py-2 "
                              type='button'
                              onClick={ResendOTP}
                            >
                              {sendingOtpReq ? (
                                // <div className="spinner-border text-spinner-color" role="status">
                                //   <span className="visually-hidden">Loading...</span>
                                // </div>
                                <div className="spinner">
                                  <div className="bounce1"></div>
                                  <div className="bounce2"></div>
                                  <div className="bounce3"></div>
                                </div>
                              ) : (
                                <> Resend OTP</>
                              )}
                            </button>
                          </div>
                          <div className="flex11-auto">
                            <button className={` mt-3 wMd100  my-md-0 mb-0 h-100 px-2 px-md-3 awaiting-border py-2 ${showStatusValue == 'OTP Received' ? 'Received' : 'Awaiting'}`}>
                              {showStatusLoader == false ? (
                                // <div className="spinner-border text-spinner-color" role="status">
                                //   <span className="visually-hidden">Loading...</span>
                                // </div>
                                <div className="spinner">
                                  <div className="bounce1"></div>
                                  <div className="bounce2"></div>
                                  <div className="bounce3"></div>
                                </div>
                              ) : (
                                <>
                                  {showStatusValue}
                                </>
                              )}
                            </button>
                          </div>
                        </div>


                        {showOtpSendError &&

                          <p className="mt16 pb10">{optSendreqMessage}</p>
                        }
                      </div>


                      <div className="bg-white d-none d-md-block">
                        {/* <img src={Wave} className="w-100" /> */}
                        <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/wave.png" alt="wave" className="w-100" />

                      </div>
                    </div>
                    <div className="col-md-4 mt-3">
                      <Questions />
                      {/* <div className="bg-Pink edge px-5 py-3">
                        <h3 className="me-auto text-white fs16 fw-800">Questions?</h3>
                        <p className="heading">
                          Don't hesitate to contact our support team on the following
                          channels.
                    </p>
                        <div className="d-flex d-sm-flex d-md-block d-lg-flex">
                          <p
                            className="text-white fs-small"
                            style={{ fontWeight: "1000" }}
                          >
                            UAN
                      </p>
                          <p className="ms-auto text-white fs-small fw-bold">
                            021 111 639 825 Ext147
                      </p>
                        </div>
                        <div className="d-flex d-sm-flex d-md-block d-lg-flex">
                          <p
                            className="text-white fs-small"
                            style={{ fontWeight: "1000" }}
                          >
                            WhatsApp
                      </p>
                      <p className="ms-auto text-white fs-small fw-bold " >
                 <a className="text-white" onClick={() => handleWhatsapp()}>+92 314 NEXTCAP (6398227)</a> 
                  </p>
                        </div>
                        <div className="d-flex d-sm-flex d-md-block d-lg-flex">
                          <p
                            className="text-white fs-small"
                            style={{ fontWeight: "1000" }}
                          >
                            Email
                      </p>
                          <p className="ms-auto text-white fs-small fw-bold">
                            cs@nextcapital.com.pk
                      </p>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  {/* ******************* Verify With OTP Write feild data Modal ****************************** */}

                  <div className="modal" tabIndex="-1" role="dialog" id="verifyOtpModal">
                    <div className="modal-dialog centerr" role="document">

                      {showVerifyingOtpWithValueModal == true &&


                        <div className="modal-content">
                          <div className="modal-header text-center border-0 mx-auto">
                            <h1
                              className="modal-title fw-bolder mt-5"
                              id="exampleModalLabel"
                            >
                              Verify OTP
                            </h1>
                            {/* <span className="close cross">&times;</span> */}
                          </div>
                          <div className="verify-modal-body  text-center">
                            {/* <p className="m-0 fw-100">
                              NCCPL have sent you a OPT oin your Registration number
                        </p>
                            <p className="p-0 ">
                              Please Enter The code that you have recieved below
                        </p> */}
                            <form onSubmit={handleSubmit}>
                              <input
                                type="text"
                                name="OTP"
                                className="form-control w-100 my-3"
                                placeholder="OTP"
                                value={otp}
                                onChange={(e) =>
                                  setOtp(e.target.value.replace(/[^0-9]/gi, ""))
                                }

                                id="OTP"
                                required
                                minLength={6}
                                maxLength={6}
                              />
                              <div className="row mt">
                                <div className="col-6">
                                  <button
                                    type="button"
                                    className="btn-outlined px-3 py-2 w-100 close"
                                    data-dismiss="verifyotpmodal"
                                    data-toggle="span"
                                    data-target="#verifyOtpModal"
                                  >
                                    Cancel
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    type="submit"
                                    className="NavButton btn px-3 py-2 w-100"
                                    onClick={() =>
                                      verifyOtpSubmit()
                                    }
                                  >
                                    Submit
                                  </button>
                                </div>
                                <p className='text-danger' >{error}</p>
                              </div>
                            </form>
                          </div>
                        </div>
                      }

                      {showVerifyingOtpModal == true &&

                        <div className="modal-content p-4">

                          <div className="modal-body container text-center ">
                            <div className="spinner-border text-spinner-color" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            {/* <div className="whitespinner">
                      <div className="bounce1"></div>
                      <div className="bounce2"></div>
                      <div className="bounce3"></div>
                      </div> */}
                          </div>

                          <div className="modal-body container text-center ">
                            <p className="fw-800 fs32 ls4 mb-0">Verifying OTP </p>
                          </div>
                          <div className="modal-body container text-center ">
                            <p className=" cursorPointer t-grey-200">
                              Your OTP is being verified. Please wait ...
                            </p>
                          </div>
                        </div>
                      }

                      {showValidatingOtpModal == true &&

                        <div className="modal-content p-4">

                          <div className="modal-body container text-center ">
                            <div className="spinner-border text-spinner-color" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            {/* <div className="whitespinner">
                      <div className="bounce1"></div>
                      <div className="bounce2"></div>
                      <div className="bounce3"></div>
                      </div> */}
                          </div>
                          <div className="modal-body container text-center ">
                            <p className="fw-800 fs32 ls4 mb-0">Validating Data</p>
                          </div>
                          <div className="modal-body container text-center">
                            <p className=" cursorPointer t-grey-200">
                              Your OTP has been verified. Please wait ...
                            </p>
                          </div>
                        </div>
                      }
                      {showThankyouModal == true &&
                        <div className="modal-content p-4">
                          <div className="modal-body container text-center ">
                            <p className="fw-800 fs32 ls4 mb-0">Congratulations!</p>
                          </div>

                          <div className="modal-body container text-center">
                            <p className=" cursorPointer t-grey-200">
                              Your OTP has been successfully submitted! Please hold tight while we complete the remaining
                              steps to open your account. <br /> <br />

                              Once we're done, you'll receive an email with your trading <br /> account credentials from us..
                            </p>
                          </div>
                          <div className="modal-body container mb-3">

                            <button
                              type="button"
                              className="w-100 NavButton btn fw-800 close"
                              data-dismiss="modal"
                              onClick={() => handleSuccessScreen()}
                            >
                              Back to Dashboard
                            </button>

                          </div>
                        </div>
                      }



                      {showValidatingOtpErrorModal == true &&
                        <div className="modal-content p-4">
                          <div className="modal-body container text-center ">

                            {/* <img src={warning} height="45" className="m-auto w-auto" alt='err' /> */}
                            <img src="https://i-invest-logos.s3.ap-southeast-1.amazonaws.com/warning.png" height="45" className="m-auto w-auto" alt='err' />
                          </div>

                          <div className="modal-body container text-center">
                            <p className=" cursorPointer t-grey-800 fs14">
                              An error occurred in your submission with the following information: <b>{validatingOtpError} </b>

                              In case of questions please contact customer support.
                            </p>
                          </div>
                          <div className="modal-body container mb-3">
                            {/* <NavLink to="/Dashboard"> */}
                            <button
                              type="button"
                              className="w-100 NavButton btn fw-800 close"
                              data-dismiss="modal"
                              onClick={() => moveToErrorScreen()}
                            >
                              Back To Form
                            </button>
                            {/* </NavLink> */}
                          </div>
                        </div>
                      }



                    </div>
                  </div>


                  {/* ******************* Resend OTP data Modal ****************************** */}

                  <div
                    className="modal"
                    tabIndex="-1"
                    role="dialog"
                    id="resendOtpModal"
                  >
                    <div className="modal-dialog centerr" role="document">
                      <div className="modal-content">
                        <div className="modal-header text-center border-0 mx-auto">
                          <h1
                            className="modal-title fw-bolder mt-5"
                            id="exampleModalLabel"
                          >
                            Verify OTP
                          </h1>
                        </div>
                        <div className="modal-body text-center">
                          <p className="m-0 fw-100">
                            NCCPL have sent you again OPT in your Registration number
                          </p>
                          <p className="p-0 ">
                            Please Enter The code that you have recieved below
                          </p>
                          <form onSubmit={handleFormSubmit}>
                            <input
                              type="text"
                              name="ReOTP"
                              className="form-control w-100 my-3"
                              placeholder="OTP"
                              value={ReOTP}
                              onChange={(e) =>
                                setReOtp(e.target.value.replace(/[^0-9]/gi, ""))
                              }
                              id="OTP"
                              required
                              minLength={6}
                              maxLength={6}
                            />
                            <div className="row">
                              <div className="col-6">
                                <button
                                  type="button"
                                  className="  btn-outlined px-3 py-2 w-100 close"
                                  data-dismiss="modal"
                                  data-toggle="span"
                                  data-target="#exampleModal"
                                >
                                  Cancel
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  type="submit"
                                  className="NavButton btn px-3 py-2 w-100"
                                >
                                  Submit
                                </button>
                              </div>
                              <p>{error}</p>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )

            // : (
            //   <SuccessFormScreen />

            // )


          }
        </>
      ) : (
        <EditFormErrorScreen errorMessage={validatingOtpError} />
      )}






    </>
  );
};

export default Otp;
